export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "js/worker.6bcbef25.worker.js");
}
